import React, { HTMLProps } from 'react';
import { HelpText, Popover, Table } from '@navikt/ds-react';
import { store } from '@/app/_components/store/store';
import Historikk from '@/components/attributt-liste/Historikk';
import { ArbeidsforholdDetaljert } from '@/types/arbeidsforhold';
import { formatDate } from '@/utils/formatting/dato';
import { hjelpetekstAriaLabel } from '@/utils/formatting/tekst';
import { css } from '@emotion/css';
import dayjs from 'dayjs';
export const getHistoriskeEndringer = (props: Pick<AttributtMedTittelProps<ArbeidsforholdDetaljert>, 'getHistorikk' | 'getValue' | 'data'>) => props.getHistorikk &&
//Show changes only if ...
props.data?.ansettelsesdetaljerhistorikk?.filter((historikk, index) => {
  if (
  // ...the first row is different from the current one in gjeldendeAnsettelsesdetaljer
  index == 0 && props.getValue!(props.data) !== props.getHistorikk!(props.data?.ansettelsesdetaljerhistorikk![index]) ||
  // ...this row is different from the next one
  index > 0 && props.getHistorikk!(historikk) !== props.getHistorikk!(props.data?.ansettelsesdetaljerhistorikk![index - 1])) return true;
}) || [];
interface AttributtMedTittelProps<T extends ArbeidsforholdDetaljert> extends Pick<HTMLProps<HTMLDivElement>, 'className' | 'style'> {
  title?: string;
  data: T;
  historikk?: React.ReactNode;
  hjelpetekst?: React.ReactNode;
  getValue: (data: T) => React.ReactNode;
  getHistorikk?: (data: ArbeidsforholdDetaljert['gjeldendeAnsettelsesdetaljer']) => React.ReactNode;
  feilmelding?: string | null;
  children?: string | React.ReactNode | React.ReactNode[];
  overskrift?: boolean;
  valgt?: boolean;
  open?: boolean;
  visHistorikk?: boolean;
  viseDetaljerForDato?: Date;
}
const AttributtMedTittel = <T extends ArbeidsforholdDetaljert,>(props: AttributtMedTittelProps<T>) => {
  const helptextRef = React.useRef(null);
  const {
    tekst
  } = store.useReducerState();
  const today = formatDate(new Date().toString())!;
  const {
    valgt,
    viseDetaljerForDato = today
  } = props;
  const [popoverVisible, setPopoverVisible] = React.useState(false);
  const historiskeEndringer = props.getHistorikk &&
  //Show changes only if ...
  props.data?.ansettelsesdetaljerhistorikk?.filter((historikk, index) => {
    if (
    // ...the first row is different from the current one in gjeldendeAnsettelsesdetaljer
    index == 0 && props.getValue!(props.data) !== props.getHistorikk!(props.data?.ansettelsesdetaljerhistorikk![index]) ||
    // ...this row is different from the next one
    index > 0 && props.getHistorikk!(historikk) !== props.getHistorikk!(props.data?.ansettelsesdetaljerhistorikk![index - 1])) return true;
  }) || [];
  const harHistoriskeEndringer = historiskeEndringer.length > 0;
  return <Table.Row shadeOnHover={false} className={css({
    textAlign: 'left',
    color: !valgt ? 'var(--ax-text-neutral-subtle)' : 'inherit'
  })}>
            <Table.HeaderCell className={css({
      verticalAlign: 'top'
    })}>
                <span {...!valgt && {
        onClick: () => setPopoverVisible(true),
        onMouseEnter: () => setPopoverVisible(true),
        onMouseLeave: () => setPopoverVisible(false)
      }} ref={helptextRef} className={css({
        display: 'flex',
        gap: 10
      })}>
                    {props.title}
                    {props.hjelpetekst && <HelpText title={hjelpetekstAriaLabel(tekst, props.title)}>{props.hjelpetekst}</HelpText>}
                    <Popover anchorEl={helptextRef.current} open={popoverVisible} onClose={() => {
          setPopoverVisible(false);
        }} placement="bottom-start">
                        <div className={css({
            padding: 6
          })}>{tekst.info.opplysningIkkeValgt}</div>
                    </Popover>
                </span>
            </Table.HeaderCell>

            {/* Dataverdien er her */}
            <Table.DataCell className={css({
      verticalAlign: 'top'
    })}>
                {!valgt ? tekst.info.opplysningIkkeValgt : props.data ?
      //Hvis vi skal vise data for dagens dato bare hent verdien fra data
      !props.viseDetaljerForDato || formatDate(viseDetaljerForDato.toString()) === today ? props.getValue(props.data) || tekst.info.ingenData :
      // Ellers hvis vi skal vise historisk verdi finn entrien i historikken for datoen
      props.getHistorikk ? props.getHistorikk!(props.data?.ansettelsesdetaljerhistorikk?.find(historikk_0 => {
        return dayjs(viseDetaljerForDato).isAfter(dayjs(historikk_0.rapporteringsmaanedFra));
      })!) : null : null}
                {props.visHistorikk && valgt && harHistoriskeEndringer && <Historikk endringer={historiskeEndringer} getHistorikk={props.getHistorikk!} />}
            </Table.DataCell>
        </Table.Row>;
};
export default AttributtMedTittel;